import { IApiClient } from "./ApiClient";

export interface IBlogService {
  GetBlog(blog: string): Promise<string | null>;
}

export default class BlogService implements IBlogService {
  private apiBase = '/api/blog';
  private apiClient: IApiClient;

  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }

  async GetBlog(blog: string): Promise<string | null> {
    try {
      const response = await this.apiClient.get<string>(`${this.apiBase}/${blog}`);
      return response && response.trim() !== '' ? response : null;
    } catch (error) {
      console.error('Error fetching blog:', error);
      return null;
    }
  }
}

